<template>
  <div class="contract-deadlint-cost" style="background: white;padding:30px;">
    <Form :model="deadlineAndCostForm.data" label-position="right" :label-width="120">
      <FormItem label="合作期限">
        <Row>
          <Col span="13">
            <DatePicker style="width:100%" v-model="deadlineAndCostForm.data.deadlineDate" type="daterange" placeholder="请选择"></DatePicker>
          </Col>
        </Row>
      </FormItem>

      <FormItem label="保证金">
        <Row>
          <Col span="13">
            <Input v-model="deadlineAndCostForm.data.deposit">
              <span slot="append">元/每房/一次性</span>
            </Input>
          </Col>
        </Row>
      </FormItem>

      <!-- 品牌授权金 start -->
      <FormItem label="品牌授权金">
        <Row>
          <Col span="13">
            <Input v-model="deadlineAndCostForm.data.licenseFee">
              <span slot="append">元/每房/一次性</span>
            </Input>
          </Col>
        </Row>
      </FormItem>

      <FormItem label="开发费返还">
        <i-switch v-model="deadlineAndCostForm.display.toggleDevelopReturnFee" size="large">
          <span slot="open">启用</span>
          <span slot="close">关闭</span>
        </i-switch>
      </FormItem>

      <FormItem label="开发费返回规则" v-show="deadlineAndCostForm.display.toggleDevelopReturnFee">
        <Row>
          <Col span="6">
            <DatePicker v-model="deadlineAndCostForm.data.developReturnFeeDaterange" type="daterange" format="yyyy-MM" placeholder="请选择"></DatePicker>
          </Col>

          <Col span="6" push="1">
            <Input v-model="deadlineAndCostForm.data.developReturnFee">
              <span slot="prepend">返还</span>
              <span slot="append">元/每房/月</span>
            </Input>
          </Col>
        </Row>
      </FormItem>
      <!-- 品牌授权金 end -->

      <!-- 运营服务费 start -->
      <FormItem label="运营服务费">
        <Row>
          <Col span="13">
            <Input v-model="deadlineAndCostForm.data.operatingFee">
              <span slot="append">元/每房/月</span>
            </Input>
          </Col>
        </Row>
      </FormItem>

      <FormItem label="促销费返回">
        <i-switch v-model="deadlineAndCostForm.display.toggleSalesReturnFee" size="large">
          <span slot="open">启用</span>
          <span slot="close">关闭</span>
        </i-switch>
      </FormItem>

      <FormItem label="促销费返回规则" v-show="deadlineAndCostForm.display.toggleSalesReturnFee">
        
        <Row v-for="(rule, index) in deadlineAndCostForm.data.salesRules" :key="index" style="margin-bottom:10px;">
          <Col span="6">
            <DatePicker v-model="rule.salesReturnFeeDaterange" type="daterange" format="yyyy-MM" placeholder="请选择"></DatePicker>
          </Col>

          <Col span="6" offset="1">
            <Input v-model="rule.salesReturnFee">
              <span slot="prepend">返还</span>
              <span slot="append">元/每房/月</span>
            </Input>
          </Col>

          <Col span="2" offset="1">
            <Button type="error" icon="minus-round" @click="removeSalesReturnRule(index)"></Button>
          </Col>

        </Row>

        <Row style="margin-top:10px;">
          <Col span="6">
            <Button type="dashed" long icon="plus-round" @click="addSalesReturnRule">添加新规则</Button>
          </Col>
        </Row>

      </FormItem>

      <!-- 运营服务费 end -->

      <!-- 经营分成率 start -->
      <FormItem label="经营分成率">
        <Row>
          <Col span="13">
            <Input v-model="deadlineAndCostForm.data.manageShareRate">
              <span slot="append">%/单</span>
            </Input>
          </Col>
        </Row>
      </FormItem>

      <FormItem label="推广费返还">
        <i-switch v-model="deadlineAndCostForm.display.togglePromotionReturnFee" size="large">
          <span slot="open">启用</span>
          <span slot="close">关闭</span>
        </i-switch>
      </FormItem>

      <FormItem label="推广费返还规则" v-show="deadlineAndCostForm.display.togglePromotionReturnFee">
        
        <Row v-for="(rule, index) in deadlineAndCostForm.data.promotionReturnRules" :key="index" style="margin-bottom:10px;">
          <Col span="6">
            <DatePicker v-model="rule.promotionReturnFeeDaterange" type="daterange" format="yyyy-MM" placeholder="请选择"></DatePicker>
          </Col>

          <Col span="6" offset="1">
            <Input v-model="rule.promotionReturnRate">
              <span slot="prepend">返还</span>
              <span slot="append">%/单</span>
            </Input>
          </Col>

          <Col span="2" offset="1">
            <Button type="error" icon="minus-round" @click="removePromotionReturnRule(index)"></Button>
          </Col>

        </Row>

        <Row style="margin-top:10px;">
          <Col span="6">
            <Button type="dashed" long icon="plus-round" @click="addPromotionReturnRule">添加新规则</Button>
          </Col>
        </Row>

      </FormItem>

      <!-- 经营分成率 end -->
    </Form>
  </div>
</template>

<script>
export default {
  data(){
    return {
      deadlineAndCostForm:{
        data:{
          // 合作期限
          deadlineDate: [],
          // 保证金
          deposit: '',
          // 品牌授权金
          licenseFee: '',
          // 开发费返回时间段
          developReturnFeeDaterange: [],
          // 开发费返回
          developReturnFee:'',
          // 运营服务费
          operatingFee: '',
          // 促销费返回规则
          salesRules: [
            {
              // 促销费返回时间段
              salesReturnFeeDaterange: [],
              // 促销费返回
              salesReturnFee: '',
            }
          ],
          // 经营分成率
          manageShareRate: '',
          // 推广费返还规则
          promotionReturnRules:[
            {
              // 推广费返还时间段
              promotionReturnFeeDaterange: [],
              // 推广费返还比例
              promotionReturnRate: ''
            }
          ]
        },
        display: {
          // 是否启用开发费管理
          toggleDevelopReturnFee: false,
          // 是否启用促销费返回
          toggleSalesReturnFee: false,
          // 是否启用推广费返还
          togglePromotionReturnFee: false,
        }
       }
    }
  },
  methods:{
    // 添加促销费返回规则
    addSalesReturnRule(){
      this.deadlineAndCostForm.data.salesRules.push({
        // 促销费返回时间段
        salesReturnFeeDaterange: [],
        // 促销费返回
        salesReturnFee: '',
      })
    },
    // 移除促销费返回规则
    removeSalesReturnRule(index){
      const REMOVE_ARR_LENGTH = 1
      this.deadlineAndCostForm.data.salesRules.splice(index,REMOVE_ARR_LENGTH)
    },
    addPromotionReturnRule(){
      this.deadlineAndCostForm.data.promotionReturnRules.push({
        // 推广费返还时间段
        promotionReturnFeeDaterange: [],
        // 推广费返还比例
        promotionReturnRate: ''
      })
    },
    // 移除推广费返还规则
    removePromotionReturnRule(index){
      const REMOVE_ARR_LENGTH = 1
      this.deadlineAndCostForm.data.promotionReturnRules.splice(index,REMOVE_ARR_LENGTH)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/blue/contract-deadline-cost.vue